import Logo from 'common/Components/Logo';
import Layout from 'common/Layouts';
import { useTranslation } from 'react-i18next';
import { FormForgetChange } from './components/FormForgetChange';

function DesktopChangePassword() {
  const { t } = useTranslation();

  const getTitle = () => {
    const pageName = t(`FormSide.ResetPasswordText`);
    const brokerName = t(`BrokerCode_${window.api?.BROKER_CODE}.Title`);
    const separateSymbol = ' - ';
    return pageName + separateSymbol + brokerName;
  };

  return (
    <Layout title={getTitle()}>
      <div className="mt-1">
        <Logo />
        <h1 className="text-5xl my-4 text-center text-L-primary-50">
          {t(`FormSide.ResetPasswordText`)}
        </h1>
        <FormForgetChange />
      </div>
    </Layout>
  );
}

export default DesktopChangePassword;
